import React from 'react'
import { Col, Container, Row } from 'reactstrap';
import Dashboard from './Dashboard'

const SessionsContainer = () => {
  
  return (
    <>
      <Dashboard pass={Sessions} activeTab={2} />
    </>
  );

}


const Sessions = () => {
  return (
    <Container className="px-4" fluid>
      <div className="px-3 pt-3">
        <Row className="pt-3">
          <Col xs="auto" className="d-flex align-items-center">
            <h4 className="head text-uppercase mb-0">All Sessions</h4>
          </Col>
        </Row>
        <p className="mt-3 font-weight-light">All Sessions will appear here(inProgress...)</p>
      </div>
    </Container>
  )
}

export default SessionsContainer;